import * as React from "react";
import { Text, Button } from "@chakra-ui/react";

interface PromptProps {
  onReload(): void;
}

const Prompt: React.FC<PromptProps> = ({ onReload }) => (
  <>
    <Text>
      Please click the &apos;Reload&apos; button to get the latest version.
    </Text>
    <Button onClick={onReload} size="sm">
      Reload
    </Button>
  </>
);

export default Prompt;
